import * as ng from 'angular';
import {CalendarModule} from './calendar/calendar-component.module';
import {ConsumiModalModule} from './consumi-modal/consumi-modal.module';
import {ConsumiFeModalModule} from './consumi-fe-modal/consumi-fe-modal.module';
import {DefaultModalModule} from './default-modal/default-modal.module';
import {DropboxAuthModule} from './dropbox-auth/dropbox-auth.module';
import {EnvRibbonModule} from './env-ribbon/env-ribbon.module';
import {FilterSelectionModule} from './filter-selection/filter-selection.module';
import {GoogleDriveAuthModule} from './google-drive-auth/google-drive-auth.module';
import {ControlloIntegrotaModule} from './controllo-integrita-modal/controllo-integrita-modal.module';
// import { MaintenanceModule } from './maintenance/maintenance.module';
import {PaginationComponentModule} from './pagination-component/pagination-component.module';
import {ResumeApplicationModalModule} from './resume-application-modal/resume-application-modal.module';
import {RetryWSModalModule} from './retry-ws-modal/retry-ws-modal.module';
import {TableComponentModule} from './table-component/table-component.module';
import {ServiceLevelAgreementModalModule} from './service-level-agreement-modal/service-level-agreement-modal.module';
import {ListiniModule} from './listini/listini.module';
import {
  ConfermaEliminaDocConservazioneModule
} from './conferma-elimina-doc-conservazione/conferma-elimina-doc-conservazione.module';
import {UploadFatturePassiveModalModule} from './upload-fatture-passive-modal/upload-fatture-passive-modal.module';
import {CopiaProfiloModalModule} from './copia-profilo-modal/copia-profilo-modal.module';
import {EditProfiloModalModule} from './edit-profilo-modal/edit-profilo-modal.module';
import {CreateRivenditoreModalModule} from './create-rivenditore-modal/create-rivenditore-modal.module';
import {EditRivenditoreModalModule} from './edit-rivenditore-modal/edit-rivenditore-modal.module';
import {DeleteRivenditoreModalModule} from './delete-rivenditore-modal/delete-rivenditore-modal.module';
import {ImportFatturePassiveModalModule} from './import-fatture-passive-modal/import-fatture-passive-modal.module';
import {CancelSubscriptionModalModule} from './cancel-subscription-modal/cancel-subscription-modal.module';
import {CodiceAttivazioneModule} from './codice-attivazione/codice-attivazione.module';
import {ApiSecretModalModule} from './api-secret-modal/api-secret-modal-module';
import {ViewDocIdConserveModalModule} from './view-doc-conserve-modal/view-doc-conserve-modal.module';

export const ComponentsModule: string =
  ng.module('archismall.components', [
    CalendarModule,
    ConsumiModalModule,
    ConsumiFeModalModule,
    DefaultModalModule,
    DropboxAuthModule,
    EnvRibbonModule,
    FilterSelectionModule,
    GoogleDriveAuthModule,
    // MaintenanceModule,
    PaginationComponentModule,
    ResumeApplicationModalModule,
    RetryWSModalModule,
    TableComponentModule,
    ServiceLevelAgreementModalModule,
    ListiniModule,
    ConfermaEliminaDocConservazioneModule,
    UploadFatturePassiveModalModule,
    CopiaProfiloModalModule,
    EditProfiloModalModule,
    CreateRivenditoreModalModule,
    EditRivenditoreModalModule,
    DeleteRivenditoreModalModule,
    ImportFatturePassiveModalModule,
    CancelSubscriptionModalModule,
    CodiceAttivazioneModule,
    ApiSecretModalModule,
    ViewDocIdConserveModalModule,
    ControlloIntegrotaModule,
  ])
    .name;




// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/commons/components/components.module.ts